import { Box, Flex } from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { FaDatabase } from "react-icons/fa";
import { GrVmMaintenance } from "react-icons/gr";
import { MdOutlineDevices } from "react-icons/md";
import { SiChatbot } from "react-icons/si";
import { fetchController } from "../../utils/FetchController/fetchController";
import useTitle from "../../utils/Hook/useTitle";
import { getHostDomain } from "../../utils/utils";
import AuthContext from "../Auth/AuthContext";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import { debounce } from "lodash";
import NewSideBar from "./NewSideBar";
const SIDEBAR_COLLAPSED_KEY = "sidebarCollapsed";

const Layout = ({ children }) => {
  const [options, setOptions] = useState([]);
  const [text, setText] = useState("");
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "1"
  );
  const toggleCollapsed = () => {
    setCollapsed((v) => {
      const next = !v;
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, next ? "1" : "0");
      return next;
    });
  };
  const agency = useContext(AgencyContext);
  const { cardBg: bg, myDetails, titleAgencyName } = agency;
  useTitle(titleAgencyName);
  const baseUrl = getHostDomain();
  const { authUser } = useContext(AuthContext);
  const [notifications, setNotifications] = useState([]);
  const [notificationsCount, setNotificationsCount] = useState();
  const [unreadNotification, setUnreadNotification] = useState([]);
  const [readedNotification, setReadedNotification] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tag, setTag] = useState("");

  useEffect(() => {
    const debouncedFetch = debounce(async (query) => {
      if (query.trim().length < 3) {
        setOptions([]);
        return;
      }

      const urlHit = `${baseUrl}/api/v1/link_tag_entity/search/entities?tag_term=${query}&page=1&size=50`;

      try {
        setLoading(true);
        const response = await fetchController(urlHit, "GET");
        setOptions(response.data.items[0]?.entities || []);
        setTag(response.data.items[0]?.tag);
      } catch (error) {
        console.error("Error fetching data:", error);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    }, 500);

    debouncedFetch(text);

    return () => debouncedFetch.cancel();
  }, [text]);

  const loadNotification = async () => {
    try {
      const Notificationresponse = await fetchController(
        baseUrl + `/api/v1/notification/latest_notifications`,
        "GET"
      );
      const SetIconToeachNotificationType =
        Notificationresponse?.data?.items.map((val, index) => {
          return {
            created_at: val.created_at,
            created_by_id: val.created_by_id,
            id: val.id,
            link: val.link,
            message: val.message,
            notification_type: val.notification_type,
            unread: val.unread,
            icon:
              val.notification_type === "conversation" ? (
                <MdOutlineDevices />
              ) : val.notification_type === "captured_intent" ? (
                <GrVmMaintenance />
              ) : val.notification_type === "datasource" ? (
                <FaDatabase />
              ) : val.notification_type === "assistant" ? (
                <SiChatbot />
              ) : (
                ""
              ),
          };
        });
      setNotifications(SetIconToeachNotificationType);
    } catch (error) {}
  };

  const filterInBsisofReadUnread = (data = []) => {
    const readedNotification = data.filter(
      (val, index) => val.unread === false
    );
    const unReadedNotification = data.filter((val, index) => val.unread);

    setNotificationsCount(unReadedNotification?.length);
    setUnreadNotification(unReadedNotification);
    setReadedNotification(readedNotification);
  };

  useEffect(() => {
    const fetchData = async () => {
      const accessToken = localStorage.getItem("token");
      if (accessToken) {
        loadNotification();
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    filterInBsisofReadUnread(notifications);
  }, [notifications]);

  return (
    <Flex h={"100vh"}>
      <Box
        h={"100%"}
        bg={bg}
        w={collapsed ? "64px" : "260px"}
        transition="width 200ms ease"
        boxShadow="md"
      >
        <NewSideBar
          collapsed={collapsed}
          onToggleCollapsed={toggleCollapsed}
        />
      </Box>

      <Box
        w={"100%"}
        h={"100%"}
        overflowY={"auto"}
        p="4"
        flex={1}
        minW={"450px"}
      >
        {children}
      </Box>
    </Flex>
  );
};

export default Layout;
